import axios from "axios";
import { urlDropdowns } from "../../../endpoints";
import { UpdatePropertyRequest } from "../../Entries/manageEntry";

export interface DynamicDropdownOption {
  id: number;
  category: string;
  name: string;
  order: number;
}

// Get all categories
export async function getDropdownCategories() {
  return await axios.get<string[]>(`${urlDropdowns}/categories`);
}

// Get all options for a given category
export async function getDynamicDropdownByCategory(category: string) {
  return await axios.get<DynamicDropdownOption[]>(
    `${urlDropdowns}/category?name=${encodeURIComponent(category)}`
  );
}

// Create new option
export async function createDropdownOption(option: DynamicDropdownOption) {
  return await axios.post<DynamicDropdownOption>(`${urlDropdowns}`, option);
}

// Update name or order
export async function updateDynamicDropdownOption(
  request: UpdatePropertyRequest
) {
  return await axios.patch(`${urlDropdowns}/update-property`, request);
}

// Delete option
export async function deleteDynamicDropdownOption(id: number) {
  return await axios.delete(`${urlDropdowns}/${id}`);
}
